/**
 * @prop --vx-circular-progress-color: The spinner color. default #fff.
 */
:host {
  display: flex;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
.mdc-circular-progress {
  position: relative;
  width: 100px;
  height: 100px;
  animation: rotate 2s linear infinite;
}
.mdc-circular-progress__path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
  stroke: var(--vx-circular-progress-color, #fff);
}